import { Colors } from '../consts/Colors';

export default class ItemZoneDone extends Phaser.GameObjects.Container {
    constructor(scene, x, y, itemData, deck) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.scene = scene;
        this.index = itemData.index;
        this.deck = deck

        let imgX = 0
        if (this.index === 2) {
            imgX = 60
        }
        this.doneImg = itemData.image;
        this.item = this.scene.add.image(imgX, 0, this.doneImg).setOrigin(0.5);
        this.add(this.item);
      
        this.itemStroke = this.scene.add.graphics();
        this.itemStroke.lineStyle(5, Colors.Elmt.Green, 1); // Définit l'épaisseur et la couleur de la bordure
        this.itemStroke.strokeRect(
            -this.item.displayWidth / 2 + imgX,
            -this.item.displayHeight / 2,
            this.item.displayWidth,
            this.item.displayHeight
        );
        this.add(this.itemStroke);
        // // this.itemStroke.setScale(0.9)
        this.itemStroke.setAlpha(0);
        this.scene.tweens.add({
            targets: this.itemStroke,
            alpha: 1,
            duration: 250,
            // ease: 'Linear',
            repeat: 2,
            yoyo: true,
            onComplete: () => {
                this.setActive()
                if (this.deck.num == 11) {
                    this.deck.nextBtn.setUnlocked()
                }

            }
        });

    }

    setActive() {
        this.setScale(0.5)
          if (this.index === 2) {
            this.item.x -= 60
        }

        this.scene.isDragging = false
        this.setSize(this.item.width, this.item.height);
        this.setInteractive({ useHandCursor: true });
        this.on('pointerover', () => {
            if (!this.scene.isDragging) {
                this.setScale(1)
                this.setDepth(1)
                if (this.index === 2) {
                    this.x += 60
                }
            }
        });
        this.on('pointerout', () => {
            if (!this.scene.isDragging) {
                this.setScale(0.5)
                this.setDepth(0)
                if (this.index === 2) {
                    this.x -= 60
                }
            }
        });
    }

    setWrong(cardImg) {
        this.isError = true;

        this.item.setTint(0xFFFFFF);
        this.item.setScale(1);
        this.item.setTexture(cardImg);
        this.itemStroke = this.scene.add.graphics();
        this.itemStroke.lineStyle(5, Colors.Elmt.Red, 1); // Définit l'épaisseur et la couleur de la bordure
        this.itemStroke.strokeRect(
            -this.item.displayWidth / 2,
            -this.item.displayHeight / 2,
            this.item.displayWidth,
            this.item.displayHeight
        );
        this.add(this.itemStroke);
        // this.itemStroke.setScale(0.9)
        this.itemStroke.setAlpha(0);
        this.scene.tweens.add({
            targets: this.itemStroke,
            alpha: 1,
            duration: 250,
            // ease: 'Linear',
            repeat: 2,
            yoyo: true,
            onComplete: () => {
                this.item.setScale(0.5);
            }
        });
        this.disableInteractive();
    }

    onPointerOver() {
        if (this.isDone) {
            this.setDepth(2);

            this.item.setScale(1);
        } else {
        }
    }
    onPointerOut() {
        if (this.isDone) {
            this.setDepth(0);
            this.item.setScale(0.5);

        } else {
        }
    }
    dragOnPointerOver() {
        this.item.setTint(0x777777);
    }
    dragOnPointerOut() {
        this.item.setTint(0xFFFFFF);
    }

    setActiveDone() {
        this.disableInteractive();
        // this.item.setStrokeStyle(0, Colors.Elmt.Green, 0);
        // this.item.setSize(this.dropZone.width, this.dropZone.height);
        this.dropZone2 = this.scene.add.rectangle(0, 0, this.item.width + 50, this.item.height + 50, Colors.Elmt.Blue, 0).setOrigin(0.5);
        this.dropZone2.setStrokeStyle(1, Colors.Elmt.Black, 0);
        this.add(this.dropZone2);

        this.dropZone2.setInteractive({ useHandCursor: true });
        this.dropZone2.on('pointerover', () => {
            this.item.setScale(1)
            this.item.setDepth(1)
        });
        this.dropZone2.on('pointerout', () => {
            this.item.setScale(0.5)
            this.item.setDepth(0)
        });
    }

}